import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

const RoleSelection = ({ onRoleSelect, user }) => {
  const [selectedRole, setSelectedRole] = useState('');
  const [error, setError] = useState('');
  const { lang } = useLanguage();
  const T = translations[lang].roleSelection;

  const roles = [
    { value: 'teacher', label: T.educator },
    { value: 'student', label: T.student },
    { value: 'other', label: T.other },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedRole) {
      setError(T.errorSelect);
      return;
    }
    onRoleSelect(selectedRole);
  };

  return (
    <div style={{ maxWidth: 500, margin: "50px auto", padding: "20px" }}>
      <h1>{T.title}</h1>
      <p style={{ color: "#666", marginBottom: "30px" }}>
        {T.subtitle}
      </p>

      {error && <div style={{ color: "red", marginBottom: "20px" }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "30px" }}>
          {roles.map((role) => (
            <div
              key={role.value}
              style={{
                border: selectedRole === role.value ? "2px solid #007bff" : "1px solid #ddd",
                borderRadius: "8px",
                padding: "20px",
                marginBottom: "15px",
                cursor: "pointer",
                backgroundColor: selectedRole === role.value ? "#f8f9ff" : "#fff",
                transition: "all 0.2s ease"
              }}
              onClick={() => {
                setSelectedRole(role.value);
                setError('');
              }}
            >
              <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                <input
                  type="radio"
                  name="role"
                  value={role.value}
                  checked={selectedRole === role.value}
                  onChange={() => {
                    setSelectedRole(role.value);
                    setError('');
                  }}
                  style={{ marginRight: "12px", transform: "scale(1.2)" }}
                />
                <h3 style={{ margin: 0, color: "#333" }}>{role.label}</h3>
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            type="submit"
            style={{
              padding: "12px 30px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500"
            }}
          >
            {T.continue}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RoleSelection;
